/**
 * ダッシュボード（新・α版）のデモ用ダミーデータの設定
 *
 * セールスデモ（11/5 カミナシDay）で、実データの代わりにこのディレクトリで生成するダミーデータを見せる。
 * Feature Flag monitoringDashboardAlpha が開いている企業はすべてダミーデータになる（企業ごとの出し分けはしない。HRMSHI-250）。
 *
 * TODO: 検証終了時は src/features/monitoringDashboardAlpha を削除する。
 * この demo ディレクトリもその削除対象に含まれる。
 */

/**
 * L2 の「該当レポート」リンクの飛び先にする、実在レポートの UUID。
 * 空ならリンクはレポート一覧（/reports）へ向ける。
 */
const showcaseReportUuids: readonly string[] = []

/** 「該当レポート」リンクの飛び先にする実在レポートの UUID */
export const getShowcaseReportUuids = (): readonly string[] =>
  showcaseReportUuids
